module.exports = __webpack_public_path__ + "img/vignettes-asso_0002_agir-pour-le-cambodge.aaad933e.jpg";